import { render, staticRenderFns } from "./SenderReceiverInfo.vue?vue&type=template&id=434cc38c"
import script from "./SenderReceiverInfo.vue?vue&type=script&lang=js"
export * from "./SenderReceiverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports